import React from "react";
import PropTypes from "prop-types";
import ReturnButton from "../ReturnButton";
import ProfileButton from "../ProfileButton";
import CheckoutButton from "../CheckoutButton";
import "./css/subNavigation.css";

const SubNavigation = ({
  showOverlay,
  loggedIn,
  customerObj,
  profileButtonAction,
  orderCheckout,
  itemCount
}) => (
  <div className="sub-navigation" data-quid="sub-navigation">
    <ReturnButton showOverlay={showOverlay} />
    <ProfileButton
      loggedIn={loggedIn}
      customerObj={customerObj}
      profileButtonAction={profileButtonAction}
    />
    <CheckoutButton orderCheckout={orderCheckout} itemCount={itemCount} />
  </div>
);

SubNavigation.propTypes = {
  showOverlay: PropTypes.func.isRequired,
  orderCheckout: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool,
  customerObj: PropTypes.shape({}),
  profileButtonAction: PropTypes.func.isRequired,
  itemCount: PropTypes.string
};

SubNavigation.defaultProps = {
  customerObj: {},
  loggedIn: null,
  itemCount: "0"
};

export default SubNavigation;
